import api from "./api";

const url = "privacy-category";

const findPrivacyCategories = () => api.get(`${url}/find-all-privacy-category`);

const findPrivacyCategoryById = (id) =>
  api.get(`${url}/find-privacy-category-by-id?id=${id}`);

export default {
  findPrivacyCategories,
  findPrivacyCategoryById,
};
